import React from 'react';
import { signOff, meta } from '../../data/caseStudy';
export function SignOff() {
  return <footer className="grid-navy w-full text-white" data-id="element-183" data-mp="2iug671vuj3os">
      <div className="accent-rule h-1 w-full" aria-hidden="true" data-id="element-184" data-mp="2it50uxmr5nvk" />
      <div className="mx-auto w-[1200px] px-20 py-20" data-id="element-185" data-mp="2nmptsb9hnrnw">
        <ul className="grid grid-cols-4 gap-5" data-id="element-186" data-mp="2skrmlnwpv5ck">
          {signOff.map(item => <li key={item} className="avoid-break rounded-2xl border border-white/10 bg-white/[0.04] px-6 py-6" data-id="element-187" data-mp="2smlxsai6rj3g">
              <span className="accent-rule block h-[3px] w-8 rounded-full" aria-hidden="true" data-id="element-188" data-mp="1zx583klyagax" />
              <p className="mt-5 font-display text-[17px] font-semibold leading-snug tracking-[-0.015em] text-white" data-id="element-189" data-mp="24u5exxqmjn33">
                {item}
              </p>
            </li>)}
        </ul>

        <div className="mt-16 flex items-center justify-between border-t border-white/10 pt-8" data-id="element-190" data-mp="3g9al5bpys3rg">
          <div className="flex items-center gap-3" data-id="element-191" data-mp="3l8dqyydrqe0h">
            <span className="accent-rule h-5 w-1 rounded-full" aria-hidden="true" data-id="element-192" data-mp="3lb9pantj34pg" />
            <p className="font-display text-[15px] font-semibold text-white" data-id="element-193" data-mp="32fd4yiwgivm2">
              Lumen Platform — FGE NexantECA
            </p>
          </div>
          <p className="font-sans text-[13px] text-white/45" data-id="element-194" data-mp="2tfzt5jkv1uy6">
            {meta[1].value} · {meta[2].value}
          </p>
        </div>
      </div>
    </footer>;
}